if (!customElements.get('cart-invoice-request')) {
  customElements.define(
    'cart-invoice-request',
    class CartInvoiceRequest extends HTMLElement {
      constructor() {
        super();
        this.saveAttributes = debounce(this.saveAttributes.bind(this), 400);
        this.handleCheckout = this.handleCheckout.bind(this);
      }

      connectedCallback() {
        this.checkbox = this.querySelector('.cart-invoice-request__checkbox');
        this.panel = this.querySelector('.cart-invoice-request__panel');
        this.errorEl = this.querySelector('[data-invoice-error]');
        this.regionSelect = this.querySelector('[name="invoice_region"]');
        this.fieldGroups = this.querySelectorAll('[data-invoice-fields]');

        this.checkbox?.addEventListener('change', () => {
          this.panel?.classList.toggle('hidden', !this.checkbox.checked);
          this.clearError();
          this.saveAttributes();
        });

        this.regionSelect?.addEventListener('change', () => {
          this.updateFieldGroups();
          this.clearError();
          this.saveAttributes();
        });

        this.querySelectorAll('input.field__input').forEach((input) => {
          input.addEventListener('input', () => {
            this.clearError();
            this.saveAttributes();
          });
        });

        document.querySelectorAll('[name="checkout"]').forEach((button) => {
          button.addEventListener('click', this.handleCheckout, true);
        });
      }

      disconnectedCallback() {
        document.querySelectorAll('[name="checkout"]').forEach((button) => {
          button.removeEventListener('click', this.handleCheckout, true);
        });
      }

      updateFieldGroups() {
        const selected = this.getSelectedRegion();
        this.fieldGroups.forEach((group) => {
          group.classList.toggle('hidden', group.dataset.invoiceFields !== selected);
        });
      }

      getSelectedRegion() {
        return this.regionSelect?.value || 'Italia';
      }

      getAttributes() {
        const emptyAttributes = {
          'Richiede fattura': '',
          'Regione fattura': '',
          'Codice fiscale': '',
          'Partita IVA': '',
          VAT: '',
          'Tipo fattura': '',
          'Ragione sociale': '',
          'SDI o PEC': '',
          'Note fattura estero': '',
        };

        if (!this.checkbox?.checked) {
          return emptyAttributes;
        }

        const region = this.getSelectedRegion();
        const cf = this.querySelector('[name="invoice_cf"]')?.value.trim() || '';
        const vat = this.querySelector('[name="invoice_vat"]')?.value.trim() || '';
        const foreignVat = this.querySelector('[name="invoice_foreign_vat"]')?.value.trim() || '';

        if (region === 'Altro') {
          return {
            ...emptyAttributes,
            'Richiede fattura': 'Si',
            'Regione fattura': region,
            VAT: foreignVat,
          };
        }

        return {
          ...emptyAttributes,
          'Richiede fattura': 'Si',
          'Regione fattura': region,
          'Codice fiscale': cf,
          'Partita IVA': vat,
          'SDI o PEC': this.querySelector('[name="invoice_sdi"]')?.value.trim() || '',
        };
      }

      validate() {
        if (!this.checkbox?.checked) return true;

        const strings = window.cartInvoiceStrings || {};
        const region = this.getSelectedRegion();

        if (region === 'Italia') {
          const cf = this.querySelector('[name="invoice_cf"]')?.value.trim();
          const vat = this.querySelector('[name="invoice_vat"]')?.value.trim();

          if (!cf && !vat) {
            this.showError(strings.italyTaxRequired || 'Enter tax ID or VAT number');
            return false;
          }
        }

        return true;
      }

      handleCheckout(event) {
        const instances = document.querySelectorAll('cart-invoice-request');
        for (const instance of instances) {
          if (!instance.validate()) {
            event.preventDefault();
            event.stopPropagation();
            instance.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            return;
          }
        }
      }

      saveAttributes() {
        const attributes = this.getAttributes();
        const body = JSON.stringify({ attributes });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).catch(() => {
          this.showError((window.cartInvoiceStrings || {}).saveError || 'Save failed');
        });
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.classList.remove('hidden');
      }

      clearError() {
        if (!this.errorEl) return;
        this.errorEl.textContent = '';
        this.errorEl.classList.add('hidden');
      }
    }
  );
}
